import { render, staticRenderFns } from "./DettaglioPagamento.vue?vue&type=template&id=13f0851c&"
import script from "./DettaglioPagamento.vue?vue&type=script&lang=js&"
export * from "./DettaglioPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports